(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("aboutMe", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                profileRecord: "=",
                modalInstance: "="
            },
            templateUrl: "app/account/edit/aboutMeView.html",
            controller: ["myAccountResource", "accountsResource", "messageService", "frameworkService", "REG_EXP", "$rootScope", "_", "$q", AboutMeCtrl],
            controllerAs: "vm"
        };
        function AboutMeCtrl(myAccountResource, accountsResource, messageService, frameworkService, REG_EXP, $rootScope, _, $q) {
            var vm = this;
            vm.$onInit = function () {
                vm.account = angular.copy(vm.profileRecord);
                vm.showErrors = false;
                vm.saving = false;
                vm.emailPattern = REG_EXP.email;
                vm.userNamePattern = REG_EXP.username;
                vm.passwordPattern = REG_EXP.password;
                vm.enabledLocalizations = frameworkService.data.tenant.enabledLocalizations;
                vm.originalUsername = vm.account.userName;
                vm.tenant = frameworkService.data.tenant;
            };
            //Check if password has special characters that are not allowed
            //If password is empty return true because user can choose not to update password
            vm.checkSpecialCharacter = function (password) {
                if (password)
                    return password.match(REG_EXP.specialCharacterPassword) != null;
                return true;
            };
            vm.saveProfile = function (isValid) {
                vm.saving = true;
                if (isValid) {
                    vm.account.oldPassword = vm.oldPassword;
                    vm.account.newPassword = vm.newPassword;
                    myAccountResource.updateMyAccountInformation(vm.account, function (result) {
                        $rootScope.$broadcast("refreshToken");
                        messageService.success("account.profile.updated");
                        vm.modalInstance.close(result);
                    }, function (error) {
                        vm.saving = false;
                        messageService.error(error);
                    });
                }
                else {
                    vm.showErrors = true;
                    vm.saving = false;
                }
            };
            vm.checkUsernameIsAvailable = function (username) {
                return $q(function (resolve, reject) {
                    if (username === vm.originalUsername)
                        resolve(true);
                    else {
                        accountsResource.isUsernameAvailable({ actionValue: username }, function (result) {
                            if (result.value)
                                resolve(true);
                            else
                                reject();
                        });
                    }
                });
            };
            vm.validateOldPassword = function (password) {
                return $q(function (resolve, reject) {
                    //Check invalid characters to avoid calling the server with harmful characters
                    if (password && password.match(/[&+%*:.<>?]/) == null) {
                        myAccountResource.isPasswordValid({ actionValue: password }, function (result) {
                            if (result.value)
                                resolve(true);
                            else
                                reject();
                        });
                    }
                    else {
                        resolve(true);
                    }
                });
            };
            vm.dismiss = function () {
                vm.modalInstance.dismiss();
            };
        }
    });
}());
